import cosmicBg from "@/assets/img/landing/cosmic-bg.webp"

import { STATS } from "../../config/landing-content"
import { LandingLogo } from "../landing-logo"

interface FooterLink {
  label: string
  href: string
}

interface OutroSectionProps {
  footerLinks: FooterLink[]
}

export function OutroSection({ footerLinks }: OutroSectionProps) {
  return (
    <section
      data-slot="outro-section"
      className="relative flex flex-col gap-8 overflow-hidden bg-dark-surface px-4 pb-4 pt-10"
    >
      <img
        src={cosmicBg}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-60 w-full object-cover"
      />

      <div className="relative z-10 flex items-center gap-4">
        <LandingLogo size="lg" className="gap-4" />
      </div>

      <h2 className="relative z-10 font-display text-2xl font-medium leading-tight text-purple-light">
        Step into clearer love, timing, and life guidance with millions already using Live Palmistry
      </h2>

      <div className="relative z-10 flex flex-col gap-3">
        <div className="grid grid-cols-2 gap-3">
          {STATS.map((stat) => (
            <div
              key={stat.value}
              className="flex flex-col rounded-[16px] bg-dark-base px-4 pb-4 pt-2"
            >
              <span className="font-display text-5xl text-main-purple">{stat.value}</span>
              <span className="mt-1 text-sm leading-snug text-purple-light/70">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 flex flex-col gap-2">
        <p className="text-center text-xs text-purple-light/40">All rights reserved. 2026</p>
        <div className="h-px w-full bg-purple-light/20" />
        <div className="flex flex-wrap items-start gap-x-0.5 gap-y-1">
          {footerLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="min-w-[67px] flex-1 text-center text-xs text-purple-light/40 transition-colors hover:text-purple-light/70"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
